import React, { useEffect, useRef, useState } from "react"
import { Link, useParams } from "react-router-dom"
import classnames from "classnames"

import getSelectionsFromParams from "../utils/getSelectionsFromParams"
import { routes } from "../routes"
import { useSmallWidthMode } from "../utils/smallWidthMode"
import ShareMenu from "../ShareButtons/"
import "./styles.scss"
import classNames from "classnames"
import DownloadMenu from "../DownloadMenu"
// let firstNavigation = true;
export default function Nav(props) {
  const params = useParams()
  const [modalOpen, setModalOpen] = useState(false)
  const [shareMenuOpen, setShareMenuOpen] = useState(false)
  const [downloadMenuOpen, setDownloadMenuOpen] = useState(false)
  const { selectedYear, selectedCountry, selectedFactor } =
    getSelectionsFromParams(params)
  const page = params.page || "/"
  const { opt1, opt2, opt3, opt4 } = params

  useEffect(() => {
    // if (firstNavigation) {
    //   firstNavigation = false
    //   return
    // }
    setTimeout(() => {
      // use timeout to ensure title & location are updated
      let page_location = window.location.toString()

      if (page_location.charAt(page_location.length - 1) !== "/") {
        page_location = page_location + "/"
      }

      window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: page_location,
      })
    }, 300)
  }, [page, opt1, opt2, opt3, opt4])

  // Unknown paths render the Overview (see App.jsx), so fall back to it here
  const activeRoute = routes.find((r) => r.url === `/${page}`) || routes[0]
  const isSmallWidthMode = useSmallWidthMode()
  const toggleMenuModal = () => {
    setModalOpen(!modalOpen)
  }
  const closeModal = () => {
    setModalOpen(false)
  }
  if (!isSmallWidthMode && modalOpen) {
    closeModal()
  }
  const links = routes.map((link) => {
    if (link.hide) {
      return null
    }
    let url = link.url
    const match = link.url === activeRoute.url

    if (link.hasInsights) {
      url = `${url}/${encodeURIComponent(selectedYear)}`
      if (selectedCountry !== "") {
        url = `${url}/${encodeURIComponent(selectedCountry)}`
      }
      if (selectedFactor !== "") {
        url = `${url}/${encodeURIComponent(selectedFactor)}`
      }
    }
    const noSpace = !link.text.includes(" ")
    return (
      <Link
        to={url}
        key={link.url}
        className={classnames({ selected: match, noSpace })}
        onClick={closeModal}
      >
        {link.text}
      </Link>
    )
  })
  const toggleShareMenu = () => {
    setShareMenuOpen(!shareMenuOpen)
  }
  const toggleDownloadMenu = () => {
    setDownloadMenuOpen(!downloadMenuOpen)
  }
  const countrySpecificPage = params.page === "country" && selectedCountry
  const downloadButtonLabel = countrySpecificPage ? "Downloads" : "Download"
  const shareButtonWrapperRef = useRef()
  const downloadButtonWrapperRef = useRef()
  return (
    <React.Fragment>
      <div ref={props.navRef} className="Nav">
        <div className="NavInner">
          <div className="titles">
            <div className="name wjptxt">
              <Link to="/">
                WJP Rule of Law Index{" "}
                <sup>
                  <small>&reg;</small>
                </sup>
              </Link>
            </div>

            <div className="links">{links}</div>
            {/* <div className='breadcrumb'>WJP Rule of Law Index {'>'} {activeRoute.text}</div> */}
          </div>
          <div className="buttons">
            <div className="pageLabel">
              {activeRoute.hide ? "" : activeRoute.text}
            </div>
            <button
              aria-label="menu"
              className="hamburger button"
              onClick={toggleMenuModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.097"
                height="11.26"
                viewBox="0 0 14.097 11.26"
              >
                <path
                  id="menu_FILL0_wght400_GRAD0_opsz48"
                  d="M6,23.26V21.853H20.1V23.26Zm0-4.926V16.926H20.1v1.408Zm0-4.926V12H20.1v1.408Z"
                  transform="translate(-6 -12)"
                  fill="#fff"
                />
              </svg>
            </button>
            <div className="shareButtonWrapper" ref={shareButtonWrapperRef}>
              <button
                aria-label="share"
                className={classnames("button", { active: shareMenuOpen })}
                onClick={toggleShareMenu}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.791"
                  height="14.854"
                  viewBox="0 0 13.791 14.854"
                >
                  <path
                    d="M13.116,11.524a2.651,2.651,0,0,0-2.061,1L7.181,10.1a2.367,2.367,0,0,0,0-1.4l3.874-2.422a2.65,2.65,0,1,0-.588-1.648,2.545,2.545,0,0,0,.106.7L6.7,7.756a2.65,2.65,0,1,0,0,3.3l3.874,2.422a2.545,2.545,0,0,0-.106.7,2.65,2.65,0,1,0,2.65-2.65Zm0-8.479a1.59,1.59,0,1,1-1.59,1.59A1.59,1.59,0,0,1,13.116,3.045ZM4.638,10.994A1.59,1.59,0,1,1,6.227,9.4,1.59,1.59,0,0,1,4.638,10.994Zm8.479,4.769a1.59,1.59,0,1,1,1.59-1.59A1.59,1.59,0,0,1,13.116,15.763Z"
                    transform="translate(-1.975 -1.969)"
                    fill="#fff"
                  />
                </svg>

                <span className="text">Share</span>
              </button>
              {shareMenuOpen ? (
                <ShareMenu
                  toggle={toggleShareMenu}
                  wrapperRef={shareButtonWrapperRef}
                />
              ) : null}
            </div>
            <div
              className="downloadButtonWrapper"
              ref={downloadButtonWrapperRef}
            >
              <button
                aria-label="download"
                className={classNames("button downloadButton", {
                  active: downloadMenuOpen,
                })}
                onClick={toggleDownloadMenu}
              >
                <span className="text">{downloadButtonLabel}</span>
                <svg
                  className="text"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.709"
                  height="7.625"
                  viewBox="0 0 12.709 7.625"
                >
                  <path
                    d="M15.354,27.225,9,20.871,10.271,19.6l5.083,5.083L20.438,19.6l1.271,1.271Z"
                    transform="translate(-9 -19.6)"
                    fill="#fff"
                  />
                </svg>
                <svg
                  className="iconOnly"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <g
                    id="Group_11992"
                    data-name="Group 11992"
                    transform="translate(-0.125 0.253)"
                  >
                    <path
                      id="Path_29893"
                      data-name="Path 29893"
                      d="M15.167,24v2.2H5.015V24H4v2.2H4a1.06,1.06,0,0,0,1.015,1.1H15.167a1.06,1.06,0,0,0,1.015-1.1h0V24Z"
                      transform="translate(-1.875 -12.149)"
                      fill="#fff"
                    />
                    <path
                      id="Path_29894"
                      data-name="Path 29894"
                      d="M15.98,8.6l-.7-.776L11.489,12V2h-1V12L6.7,7.828,6,8.6l4.99,5.5Z"
                      transform="translate(-2.774 -1.23)"
                      fill="#fff"
                    />
                    <g
                      id="_Transparent_Rectangle_"
                      data-name=" Transparent Rectangle "
                      transform="translate(0.119 -0.26)"
                    >
                      <rect
                        id="Rectangle_7848"
                        data-name="Rectangle 7848"
                        width="16"
                        height="16"
                        transform="translate(0.007 0.007)"
                        fill="none"
                      />
                    </g>
                  </g>
                </svg>
              </button>
              {downloadMenuOpen ? (
                <DownloadMenu
                  wrapperRef={downloadButtonWrapperRef}
                  showCountryDownloads={countrySpecificPage}
                  toggle={toggleDownloadMenu}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className={classnames("modalMenu", { open: modalOpen })}>
        {links}
        {/* <a target="_blank" rel="noopener noreferrer" href="https://worldjusticeproject.org/our-work/research-and-data/wjp-rule-law-index-2021">
          <span>
            Learn more about the WJP Rule of Law Index
            <img src={externalLinkIcon} alt='external link' style={{ width: '1em' }} />
          </span>
        </a> */}
      </div>
    </React.Fragment>
  )
}
